import { t } from 'i18next';

export const rolesAndPermissionsTabs = {
  roles: {
    key: 'roles',
    label: t('settings.rolesAndPermissions.roles'),
  },
  permissions: {
    key: 'permissions',
    label: t('settings.rolesAndPermissions.permissions'),
  },
};
